import {PaginationDto} from "../../common/dto/PaginationDto";

export class MailTemplateSearchCondition extends PaginationDto {
    code: string = '';
    name: string = '';
}